import { useEffect, useState } from "react";
import { analyticsClient } from "../apiClient/analyticsClient";
import type { PageViewStats } from "../types/analytics.types";

export function AnalyticsAdminPage() {
  const [stats, setStats] = useState<PageViewStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void analyticsClient
      .getPageViewStats()
      .then(setStats)
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load page view stats."))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Page view analytics</h1>
          <p className="page-sub">How many times each page was opened, last 30 days.</p>
        </div>
      </header>

      {error ? (
        <div className="state-panel">
          <p>{error}</p>
        </div>
      ) : isLoading ? (
        <div className="state-panel">Loading…</div>
      ) : !stats || stats.byPage.length === 0 ? (
        <div className="state-panel">
          <p>No page views recorded yet — check back after people start using the site.</p>
        </div>
      ) : (
        <>
          <p className="analytics-summary">
            <strong>{stats.totalViews.toLocaleString()}</strong> total page views in the last {stats.rangeDays} days.
          </p>
          <div className="analytics-table-wrap">
            <table className="analytics-table">
              <thead>
                <tr>
                  <th>Page</th>
                  <th>Views</th>
                </tr>
              </thead>
              <tbody>
                {stats.byPage.map((row) => (
                  <tr key={row.page}>
                    <td>{row.page}</td>
                    <td>{row.views.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
